/**
 * Whether the player has rated this lesson already, from any of the places a
 * rating lands: the server's mark (ratedAt, rateLiveLesson), the booking's
 * own playerRating (the finished page's, decision 51), the pair's room
 * (ratings.{uid}, for this booking), or this device (kept until the callable
 * takes it). Asked once per lesson (finding 17). Pure, so tested.
 */
export function lessonRated(p: {
  booking: { id: string; ratedAt?: string | null; playerRating?: { stars?: number } | null };
  roomRating?: { stars?: number; bookingId?: string } | null;
  kept?: Array<{ bookingId: string; stars?: number }>;
}): boolean {
  if (p.booking.ratedAt || (p.booking.playerRating?.stars ?? 0) > 0) return true;
  if (p.roomRating?.bookingId === p.booking.id && (p.roomRating.stars ?? 0) > 0) return true;
  return (p.kept ?? []).some((k) => k.bookingId === p.booking.id && (k.stars ?? 0) > 0);
}

/**
 * The room's word, read after the stars are already up (the walk of 28
 * October: they took seconds to appear on a phone while it loaded). It hides
 * them only when it says this lesson is rated and nothing has been tapped.
 */
export function roomHidesRating(roomRating: { stars?: number; bookingId?: string } | null | undefined, bookingId: string, tapped: number): boolean {
  return tapped === 0 && roomRating?.bookingId === bookingId && (roomRating.stars ?? 0) > 0;
}
